import $ from 'jquery'
import 'jquery-validation/dist/jquery.validate.min'
import queryString from 'query-string'

export default {
  init() {
    if($('option[data-name="GIPSI"]').length === 0){
      $('#gipsi').hide();
      return;
    }
    $('form.filter-form').on('submit', function (e) {
      e.preventDefault();
      window.location = '/espace-adherent/base-documentaire?' + queryString.stringify({'category': e.target.category.value});
    });

    $('#gipsi').on('click', function(e){
      //$('select[name="category"]').val($('option[data-name="GIPSI"]').val());
      e.preventDefault()
      window.location = '/espace-adherent/base-documentaire?' + queryString.stringify({'category': $('option[data-name="GIPSI"]').val()});
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/espace-adherent-documents.js